import { Form } from 'react-bootstrap';
import { Control, Controller, RegisterOptions, useFormContext } from 'react-hook-form';

type TextInputProps = {
	onChange?: (e: string) => void;
	type: 'text' | 'email' | 'number' | 'hidden' | 'date';
	id?: string;
	name: string;
	className?: string;
	containerClass?: string;
	label?: string;
	placeholder?: string;
	bsPrefix?: string;
	helpText?: string | any;
	readOnly?: boolean;
	disabled?: boolean;
	errors?: any;
	control?: Control<any>;
	register?: RegisterOptions;
};

export default function TextInput({
	name,
	id,
	className,
	containerClass,
	label,
	placeholder,
	helpText,
	errors,
	register,
	type,
	onChange,
	disabled = false,
	...props
}: TextInputProps) {
	const { control } = useFormContext();

	return (
		<Controller
			name={name}
			control={control}
			render={({ field, fieldState }) => (
				<Form.Group className={containerClass ?? ''}>
					{label && <Form.Label>{label}</Form.Label>}
					<Form.Control
						id={id}
						type={type}
						{...props}
						{...field}
						value={field.value ?? ''}
						onChange={(e) => {
							field.onChange(e.target.value);
							if (onChange !== undefined) onChange(e.target.value);
						}}
						placeholder={placeholder}
						className={className}
						isInvalid={Boolean(fieldState.error?.message || (errors && errors[name]))}
						disabled={disabled}
					/>
					{helpText && (
						<Form.Text id={`${name}-help`} muted>
							{helpText}
						</Form.Text>
					)}
					{fieldState.error?.message && (
						<Form.Control.Feedback type="invalid">
							{fieldState.error?.message}
						</Form.Control.Feedback>
					)}
					{errors && errors[name] && (
						<Form.Control.Feedback type="invalid">
							{typeof errors[name] === 'string' && errors[name]}
							{errors[name]?.message}
							{errors[name] &&
								Array.isArray(errors[name]) &&
								errors[name].map((message: string) => message)}
						</Form.Control.Feedback>
					)}
				</Form.Group>
			)}
		/>
	);
}
